import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFocalPoint12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFocalPoint12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#FocalPoint12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M2.917 1.917a1 1 0 0 0-1 1v1.378a.5.5 0 1 1-1 0V2.917a2 2 0 0 1 2-2h1.378a.5.5 0 1 1 0 1zm7.166 2.378V2.917a1 1 0 0 0-1-1H7.704a.5.5 0 1 1 0-1h1.38a2 2 0 0 1 2 2v1.378a.5.5 0 0 1-1 0m-1 5.788h-1.38a.5.5 0 1 0 0 1h1.38a2 2 0 0 0 2-2V7.704a.5.5 0 0 0-1 0v1.38a1 1 0 0 1-1 1m-7.166-1a1 1 0 0 0 1 1h1.378a.5.5 0 1 1 0 1H2.917a2 2 0 0 1-2-2v-1.38a.5.5 0 1 1 1 0zm4.08-2.46a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="FocalPoint12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconFocalPoint12);
